export default __webpack_public_path__ + "static/media/TEN-BNB.349dca22.svg";